/**
 * The lump-sum discount that reps can apply via "Edit Final Price" is not
 * enforced server-side — this is an ADVISORY nag only, not an authorization control.
 * Above this fraction of the Base Items Total the checkout pops a confirm
 * dialog, but any SALES rep can click through (no role gate, no audit record).
 * A discount-approval initiative (rep <=X% / SALES_MANAGER above) is a separate
 * future effort per CLAUDE.md. Raising this ratio only changes how often the
 * nag fires; the hard money control (Math.min(lumpSumDiscount,
 * effectiveItemsTotal) in useQuoteSummary) is unchanged.
 */
export const DISCOUNT_WARN_RATIO = 0.25;

/** True when `requiredDiscount` exceeds DISCOUNT_WARN_RATIO of the base items
 *  total, i.e. the rep should be nagged to authorise it. Exclusive boundary:
 *  exactly the ratio does NOT warn. */
export function requiresDiscountAuthorisation(
  requiredDiscount: number,
  baseItemsTotal: number,
): boolean {
  return requiredDiscount > baseItemsTotal * DISCOUNT_WARN_RATIO;
}
